export const rolesNotAllowToSettingTab: Role[] = [
  'HR',
  'TECHNICIAN',
  'HR_ASSISTANT'
];
